class PackSelectorHandler {
    constructor(sectionId) {
        this.sectionId = sectionId;
        this.quantityForm = document.querySelector(`#Quantity-Form-${sectionId}`);
        this.quantityInput = document.getElementById(`Quantity-${sectionId}`);
        this.priceContainer = document.getElementById(`price-${sectionId}`);
        this.packPriceDisplay = document.getElementById(`pack-price-${sectionId}`);
        this.packRadios = document.querySelectorAll(`.pack-selector[data-section-id="${sectionId}"] .pack-radio`);
        this.paymentTermsContent = document.querySelector('#shopify-installments #shopify-installments-content');
        this.variantChangeUnsubscriber = undefined;

        if (!this.quantityForm || !this.packRadios.length) return;

        this.init();
    }

    init() {
        console.log('window.Shopify?.currency?.active', window.Shopify?.currency?.active);
        const initialPack = document.querySelector(
            `.pack-selector[data-section-id="${this.sectionId}"] .pack-radio:checked`
        );
        if (initialPack && this.quantityInput) {
            const packQuantity = parseInt(initialPack.dataset.packQuantity);
            this.updateQuantity(packQuantity);
        }

        this.packRadios.forEach((radio) => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    const packQuantity = parseInt(radio.dataset.packQuantity);
                    this.updateQuantity(packQuantity);
                    setTimeout(() => this.updatePackPrice(), 100);
                }
            });
        });

        this.initExpandButton();

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId === this.sectionId) {
                    setTimeout(() => this.updatePackPrice(), 200);
                }
            });
        }

        setTimeout(() => this.updatePackPrice(), 300);
    }

    initExpandButton() {
        const packSelector = document.querySelector(`.pack-selector[data-section-id="${this.sectionId}"]`);
        if (!packSelector) return;

        const expandButton = packSelector.querySelector('.pack-expand-button');
        if (!expandButton) return;

        const hiddenOptions = packSelector.querySelectorAll('.pack-option-hidden');
        const expandIcon = expandButton.querySelector('.pack-expand-icon');

        expandButton.addEventListener('click', () => {
            const isExpanded = packSelector.classList.contains('expanded');

            if (isExpanded) {
                packSelector.classList.remove('expanded');
                expandButton.setAttribute('aria-expanded', 'false');
                hiddenOptions.forEach((option) => {
                    option.style.display = 'none';
                });
                if (expandIcon) expandIcon.style.transform = 'rotate(0deg)';
            } else {
                packSelector.classList.add('expanded');
                expandButton.setAttribute('aria-expanded', 'true');
                hiddenOptions.forEach((option) => {
                    option.style.display = 'flex';
                });
                if (expandIcon) expandIcon.style.transform = 'rotate(180deg)';
            }
        });
    }

    updateQuantity(packQuantity) {
        if (!this.quantityInput) return;

        this.quantityInput.value = packQuantity;

        const changeEvent = new Event('change', { bubbles: true });
        this.quantityInput.dispatchEvent(changeEvent);

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        }
    }

    updatePackPrice() {
        if (!this.priceContainer || !this.packPriceDisplay) return;

        const selectedPack = document.querySelector(
            `.pack-selector[data-section-id="${this.sectionId}"] .pack-radio:checked`
        );
        if (!selectedPack) return;

        const packQuantity = parseInt(selectedPack.dataset.packQuantity);
        const currentQuantity = parseInt(this.quantityInput?.value || packQuantity);

        const variant = this.getSelectedVariant();
        if (variant && variant.price) {
            const unitPrice = variant.price;
            const totalPrice = unitPrice * currentQuantity;
            const compareAtPrice = variant.compare_at_price;
            const totalCompareAtPrice = compareAtPrice ? compareAtPrice * currentQuantity : null;
            this.renderPackPrice(totalPrice, totalCompareAtPrice, unitPrice, compareAtPrice);
        } else {
            this.updatePriceFromDOM(currentQuantity);
        }
    }

    updatePriceFromDOM(quantity) {
        let priceElement = this.priceContainer.querySelector('.price-item--sale.price-item--last');
        if (!priceElement) {
            priceElement = this.priceContainer.querySelector(
                '.price-item--regular:not(.variant-item__old-price):not(s)'
            );
        }
        if (!priceElement) {
            priceElement = this.priceContainer.querySelector('.price-item:not(.variant-item__old-price):not(s)');
        }

        const comparePriceElement = this.priceContainer.querySelector('.variant-item__old-price, s.price-item');

        if (!priceElement) {
            console.warn('Pack selector: Could not find price element');
            return;
        }

        const priceText = priceElement.textContent.trim();

        const priceMatch = priceText.match(/[\d,]+\.?\d*/);

        if (!priceMatch) {
            console.warn('Pack selector: Could not parse price from:', priceText);
            return;
        }

        let priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));

        const unitPrice = Math.round(priceValue * 100);
        const totalPrice = unitPrice * quantity;

        let compareAtPrice = null;
        if (comparePriceElement) {
            const compareText = comparePriceElement.textContent.trim();
            const compareMatch = compareText.match(/[\d,]+\.?\d*/);
            if (compareMatch) {
                let compareValue = parseFloat(compareMatch[0].replace(/,/g, ''));
                compareAtPrice = Math.round(compareValue * 100);
            }
        }

        const totalCompareAtPrice = compareAtPrice ? compareAtPrice * quantity : null;
        this.renderPackPrice(totalPrice, totalCompareAtPrice, unitPrice, compareAtPrice);
    }

    renderPackPrice(totalPrice, totalCompareAtPrice, unitPrice, compareAtPrice) {
        const totalPriceElement = this.packPriceDisplay.querySelector('.pack-total-price');
        const unitPriceElement = this.packPriceDisplay.querySelector('.pack-unit-price');

        if (!totalPriceElement || !unitPriceElement) return;

        const formatMoney = (cents) => {
            const existingPrice = this.priceContainer.querySelector('.price-item');
            if (existingPrice) {
                const existingText = existingPrice.textContent.trim();
                if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    try {
                        return Shopify.formatMoney(cents, window.money_format || '{{amount}}');
                    } catch (e) {}
                }

                const hasCurrencySymbol = /[^\d,.\s]/.test(existingText);
                if (hasCurrencySymbol) {
                    const locale = document.documentElement.lang || 'en';
                    return new Intl.NumberFormat(locale, {
                        style: 'currency',
                        currency: window.Shopify?.currency?.active || 'USD',
                        minimumFractionDigits: 2,
                    }).format(cents / 100);
                }
            }

            return (cents / 100).toFixed(2);
        };

        if (totalCompareAtPrice && totalCompareAtPrice > totalPrice) {
            totalPriceElement.innerHTML = `
        <span class="price-item price-item--sale price-item--last">${formatMoney(totalPrice)} ${
                window.Shopify?.currency?.active
            }</span>
        <s class="price-item price-item--regular variant-item__old-price">${formatMoney(totalCompareAtPrice)} ${
                window.Shopify?.currency?.active
            }</s>
      `;
        } else {
            totalPriceElement.innerHTML = `<span class="price-item price-item--regular price-item--last">${formatMoney(
                totalPrice
            )} ${window.Shopify?.currency?.active}</span>`;
        }

        const unitPriceFormatted = formatMoney(unitPrice);
        unitPriceElement.innerHTML = `
      <span class="pack-unit-label">(${unitPriceFormatted} each)</span>
    `;

        this.packPriceDisplay.style.display = 'flex';
        const regularPrice = this.priceContainer.querySelector('.price__container');
        if (regularPrice) {
            regularPrice.style.display = 'none';
        }
    }

    getSelectedVariant() {
        const variantSelects = document.querySelector(`variant-selects`);
        if (variantSelects) {
            const selectedVariantElement = variantSelects.querySelector('[data-selected-variant]');
            if (selectedVariantElement && selectedVariantElement.innerHTML) {
                try {
                    const variant = JSON.parse(selectedVariantElement.innerHTML);
                    if (variant && variant.price) {
                        return variant;
                    }
                } catch (e) {}
            }
        }

        return null;
    }

    destroy() {
        if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
        }
    }
}

if (!window.packSelectorHandlers) {
    window.packSelectorHandlers = {};
}

function initPackSelectors() {
    document.querySelectorAll('.pack-selector').forEach((selector) => {
        const sectionId = selector.dataset.sectionId;
        if (sectionId && !selector.dataset.initialized) {
            selector.dataset.initialized = 'true';
            const handler = new PackSelectorHandler(sectionId);
            window.packSelectorHandlers[sectionId] = handler;
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackSelectors);
} else {
    initPackSelectors();
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event.data?.sectionId;
        if (sectionId) {
            const handler = window.packSelectorHandlers[sectionId];
            if (handler) {
                setTimeout(() => handler.updatePackPrice(), 200);
            } else {
                setTimeout(initPackSelectors, 100);
            }
        } else {
            setTimeout(initPackSelectors, 100);
        }
    });
}
